import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { UserPlus, ArrowLeft, Loader2 } from 'lucide-react';
import { getApiError } from '../services/api';

const RegisterPremium = () => {
  const navigate = useNavigate();
  const { registerPremium } = useAuth();
  const { isDarkMode } = useTheme();
  const [form, setForm] = useState({
    sponsor_username: '',
    first_name: '', last_name: '', email: '', country: '', phone: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await registerPremium(form);
      setSuccess(true);
    } catch (err) {
      setError(getApiError(err, err.message || 'Error al registrarse'));
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 max-w-md w-full text-center shadow-xl">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <UserPlus className="w-8 h-8 text-green-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Registro Exitoso</h2>
          <p className="text-gray-500 dark:text-gray-400 mb-6">
            Te hemos enviado un correo a <strong>{form.email}</strong> con un enlace para establecer tu contraseña.
          </p>
          <Link to="/login" className="text-orange-600 hover:text-orange-700 font-medium">
            Ir a Iniciar Sesión
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <button onClick={() => navigate('/login')} className="flex items-center gap-2 text-gray-600 dark:text-gray-300 hover:text-orange-600 mb-6">
          <ArrowLeft className="w-4 h-4" /> Volver
        </button>
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-xl">
          <div className="text-center mb-4">
            {isDarkMode ? (
              <img src="/sttora.png" alt="STTORA" className="h-12 mx-auto" />
            ) : (
              <div className="inline-block p-2 bg-gray-800 rounded-xl">
                <img src="/sttora.png" alt="STTORA" className="h-10" />
              </div>
            )}
          </div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 text-center">Registro Cliente Premium</h1>
          <p className="text-gray-500 dark:text-gray-400 mb-6 text-center">Completa tus datos para registrarte gratis</p>
          {error && <div className="bg-red-50 dark:bg-red-900/30 text-red-600 text-sm p-3 rounded-xl mb-4">{error}</div>}
          <form onSubmit={handleSubmit} className="space-y-4">
            <input name="sponsor_username" placeholder="Usuario del Patrocinador *" required value={form.sponsor_username} onChange={handleChange}
              className="w-full p-3 border rounded-xl dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
            <div className="grid grid-cols-2 gap-4">
              <input name="first_name" placeholder="Nombre *" required value={form.first_name} onChange={handleChange}
                className="p-3 border rounded-xl dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
              <input name="last_name" placeholder="Apellido *" required value={form.last_name} onChange={handleChange}
                className="p-3 border rounded-xl dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
            </div>
            <input name="email" type="email" placeholder="Correo Electrónico *" required value={form.email} onChange={handleChange}
              className="w-full p-3 border rounded-xl dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
            <input name="country" placeholder="País *" required value={form.country} onChange={handleChange}
              className="w-full p-3 border rounded-xl dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
            <input name="phone" placeholder="Teléfono (opcional)" value={form.phone} onChange={handleChange}
              className="w-full p-3 border rounded-xl dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
            <button type="submit" disabled={loading}
              className="w-full bg-indigo-600 text-white py-3 rounded-xl font-semibold hover:bg-indigo-700 disabled:opacity-50 flex items-center justify-center gap-2">
              {loading ? <><Loader2 className="w-5 h-5 animate-spin" /> Registrando...</> : 'Registrarse Gratis'}
            </button>
          </form>
          <p className="text-center text-sm text-gray-500 mt-4">
            ¿Eres Gestor? <Link to="/register/gestor" className="text-indigo-600 hover:underline">Regístrate aquí</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPremium;
